import React from "react";
import EconomicTable from "../EconomicTable";
import { useFundamentalsData } from "../../../context/FundamentalsContext";

const MicroTab = () => {
    const { filteredRows: rows } = useFundamentalsData();

    const data = rows
        .filter(row => row.Category === "MICRO")
        .map(row => {
            let topic = row.Topic;
            if (!topic) return row;
            const upperTopic = topic.toUpperCase().trim();
            if (upperTopic.includes("COMPANY")) {
                topic = "Company";
            } else if (upperTopic.includes("SECTOR")) {
                topic = "Sector";
            }
            return { ...row, Topic: topic };
        });

    // Define groupDescriptions here or import it if it's from another file
    // For the purpose of making the provided Code Edit syntactically correct,
    // we'll define a placeholder here.
    const groupDescriptions = {};

    return <EconomicTable data={data} title="Micro Analysis" defaultRowData={{ Category: "MICRO", Topic: "Company" }} groupBy="Topic" groupOrder={["Company", "Sector"]} groupDescriptions={groupDescriptions} useDataHook={useFundamentalsData} showNextRelease={false} />;
};

export default MicroTab;
